/* eslint-disable react/prop-types */
import React from "react";
import tw, { css, theme } from "twin.macro";

const VideoSection = ({ data }) => {
  const { backgroundColor, url } = data;

  return (
    <section
      css={[
        css`
          background-color: ${backgroundColor?.hex || `white`};
        `,
        tw`relative block`
      ]}
    >
      <div
        css={[
          tw`w-full h-[56.2vw] relative block md:p-16`,
          css`
            & > iframe {
              width: 100%;
              height: 100%;
            }
          `
        ]}
        dangerouslySetInnerHTML={{ __html: url }}
      />
    </section>
  );
};

export default VideoSection;
